import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getSession } from "~/lib/helperFuncation/sessionStorageService";
import { SHOW_SUPER_HEADER } from "~/utils/constant";

interface HeaderState {
  canGoBack: boolean;
  direction: "forward" | "back";
  isSupperHeader?: boolean;
}

const initialState: HeaderState = {
  canGoBack: false,
  direction: "forward",
  isSupperHeader: JSON.parse(getSession(SHOW_SUPER_HEADER) || "false"),
};

const headerSlice = createSlice({
  name: "header",
  initialState,
  reducers: {
    setCanGoBack(state, action: PayloadAction<boolean>) {
      state.canGoBack = action.payload;
    },
    setDirection(state, action: PayloadAction<"forward" | "back">) {
      state.direction = action.payload;
    },
    setIsSupperHeader(state, action: PayloadAction<boolean>) {
      state.isSupperHeader = action.payload;
    },
  },
});

export const { setCanGoBack, setDirection, setIsSupperHeader } = headerSlice.actions;

export default headerSlice.reducer;
